import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SaveCustomModelPriceRequest, SaveCustomModelPriceResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export const useSaveCustomModelPrice = (authToken: string, workspaceId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation<SaveCustomModelPriceResponse, Error, SaveCustomModelPriceRequest>({
    mutationFn: async (request: SaveCustomModelPriceRequest) => {
      const response = await fetch(ENDPOINTS.custom_model_prices.list(String(workspaceId)), {
        method: "POST",
        headers: jsonAuthHeaders(authToken),
        body: JSON.stringify(request),
      });
      return handleResponse(response);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customModelPrices", workspaceId] });
      queryClient.invalidateQueries({ queryKey: ["customModelPriceSuggestions", workspaceId] });
    },
    onError: (error: Error) => displayErrorToast(error.message),
  });
};
